import {required} from "vuelidate/lib/validators";

export const awsS3Compatible = (t, regionOptions, regionPlaceholder) => (
  {
    rows: [
      {
        blocks: [
          {
            fields: [
              {
                name: 'bucketName',
                type: 'text',
                placeholder: t('common.bucketName')
              },
              {
                name: 'accessKey',
                type: 'text',
                placeholder: t('settings.connections.accessKey')
              },
              {
                name: 'secretKey',
                type: 'text',
                placeholder: t('settings.connections.secretKey'),
              },
              {
                name: 'region',
                label: '',
                type: 'i-dropdown',
                placeholder: regionPlaceholder,
                allowEmpty: false,
                options: regionOptions
              },
              {
                name: 'endpointUrl',
                type: 'text',
                placeholder: t('settings.connections.s3CompatibleEndpoint')
              },
            ]
          },
        ]
      }
    ],
    validations: {
      bucketName: {
        required
      },
      accessKey: {
        required
      },
      secretKey: {
        required
      },
      region: {
        required
      },
      endpoint: {
        required
      }

    },
    errors: {
      bucketName: {
        required: t("settings.connections.bucketNameRequired"),
      },
      accessKey: {
        required: t("settings.connections.accessKeyRequired"),
      },
      secretKey: {
        required: t("settings.connections.secretKeyRequired"),
      },
      region: {
        required: t("settings.connections.regionRequired"),
      },
      endpoint: {
        required: t("settings.connections.endpointRequired"),
      }
    }
  })
